import React from "react";
import Button from "../../../Button/Button";

const WelcomeStep = ({ handleNextStep }) => {
  return (
    <>
      <p className="font-font-Montserrat font-semibold text-[20px] sm:text-[28px] text-[#FAAD14] text-center leading-[22px] sm:leading-[36px] mt-4 sm:mt-20 md:mt-28 lg:mt-36">
        Welcome to SILC Membership
      </p>
      <p className="font-font-Titillium font-normal text-[14px] sm:text-[22px] text-[#262626] text-center leading-[20px] sm:leading-[33px] mt-4 sm:my-8 tracking-[0.0094em]">
        Membership is your passport to access the numerous services available
        when you need it most. Depending on your level and the type of coverage
        you choose, you can access the service(s) within hours of signing up to
        attend to your concerns.
      </p>
      <Button
        name={`Get Started >`}
        onClickHandler={handleNextStep}
        divStyle="justify-center"
        classNames="hover:bg-[#FFC53D] w-[193px]"
      />
      <ul className="list-disc mt-24">
        <li className="list-disc">
          <p>
            Initial consultations will be conducted under Covid 19 requirements.
          </p>
        </li>
        <li className="list-disc">
          <p>
            Your first point of contact will be via telephone consult followed
            by in person visit once initial screening and medical concerns
            indicate that it is safe to deliver the service..
          </p>
        </li>
      </ul>
    </>
  );
};

export default WelcomeStep;
